import { INSIDER_TERMS_CONDITIONS_FORCED_ACCEPTANCE_ENABLED_240529 } from "@faire/web-api/indigofair/settings/INSIDER_TERMS_CONDITIONS_FORCED_ACCEPTANCE_ENABLED_240529";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingInsiderTermsAndConditionsForcedAcceptanceEnabled =
  (): boolean =>
    getSettingValueWithoutAssignment(
      INSIDER_TERMS_CONDITIONS_FORCED_ACCEPTANCE_ENABLED_240529,
      false
    );
